export default __webpack_public_path__ + "assets/models/416defd532f29f7833d1d89a8d3ded91.glb";